module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/tabbar/tab-panel.component.html
// module id = 85
// module chunks = 0 1